let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("alBoB")).then(() => parcelRequire('cql7z'));